<div>
    <!-- Header -->
    <h1 mat-dialog-title class="text-center font-weight-bold">Import Twilio Phone Number</h1>

    <mat-divider></mat-divider>

    <!-- Content -->
    <div mat-dialog-content class="pt-3">
        <form [formGroup]="importForm" class="container">
            <div class="d-flex align-items-center justify-content-center">
                <mat-form-field appearance="outline" class="w-50 m-1">
                    <mat-label>Phone number</mat-label>
                    <input matInput placeholder="Ex. (819) 800-9303" formControlName="phoneNumber" required>
                    <mat-hint>Assistant twilio phone number friendly name</mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-50 m-1">
                    <mat-label>Phone number sid</mat-label>
                    <input matInput placeholder="Ex. PNaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa" formControlName="phoneSid" required>
                    <mat-hint>Assistant twilio phone number sid</mat-hint>
                </mat-form-field>
            </div>

            <div class="d-flex align-items-center justify-content-center">
                <mat-form-field appearance="outline" class="w-50 m-1">
                    <mat-label>Account Token</mat-label>
                    <input type="password" matInput placeholder="Ex. ADaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa" formControlName="accountToken" required>
                    <mat-hint>Assistant twilio account token</mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-50 m-1">
                    <mat-label>Account Sid</mat-label>
                    <input matInput placeholder="Ex. ACaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa" formControlName="accountSID" required>
                    <mat-hint>Assistant twilio account sid</mat-hint>
                </mat-form-field>
            </div>
        </form>
    </div>


    <mat-divider></mat-divider>

    <!-- Actions -->
    <div mat-dialog-actions class="d-flex justify-content-around">
        <button mat-raised-button mat-dialog-close color="warn" class="w-25">Cancel</button>
        <button [disabled]="!importForm.valid || isLoading" mat-raised-button color="primary" (click)="onImportTwilio()" class="w-25">
            <span *ngIf="!isLoading">Save</span>
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3"
            class="mx-auto mat-spinner"></mat-spinner>
        </button>
    </div>
</div>